export const formatPriceEstimate = (value) =>
  value === 'TBD' ? value : `$${value || 0}`;
